module.exports = __webpack_public_path__ + "static/img/google_btn.676694f5.webp";